import _taggedTemplateLiteral from '../../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled } from '@mgmresorts/wcl-styled';
import { RoomBookingNavigation } from '../../RoomBookingNavigation/RoomBookingNavigation.es.js';
import { CenteredNavTitle } from '../../RoomBookingNavigation/elements/CenteredNavTitle.es.js';
import '../../RoomBookingNavigation/elements/CenterPropertyLogo.es.js';
import '../../RoomBookingNavigation/elements/LeftBackButton.es.js';
import '../../RoomBookingNavigation/elements/LeftCloseButton.es.js';
import '../../../../../node_modules/@babel/runtime/helpers/slicedToArray.es.js';
import 'react';
import '../../DropdownMenu/MenuTrigger/MenuTrigger.es.js';
import '../../DropdownMenu/MenuTrigger/MenuContent.styles.es.js';
import '../../DropdownMenu/MenuButton/MenuButton.es.js';
import '../../MlifeMenu/MlifeMenu/MlifeMenu.es.js';
import '../../MlifeMenu/MlifeMenu/MlifeMenuLoginForm.es.js';
import '../../../../../node_modules/@babel/runtime/helpers/typeof.es.js';
import '../../Box/Box.es.js';
import '../../Box/FlexColumn.es.js';
import '../../Box/FlexRow.es.js';
import '../../Box/GridColumn.es.js';
import '../../Box/GridRow.es.js';
import '../../Button/Button.es.js';
import '../../Button/FixedButton.es.js';
import '../../Button/Button.styles.es.js';
import '../../ButtonGroup/ButtonGroup.es.js';
import { Text16, Heading20 } from '../../Text/Text.es.js';
import '../../MlifeMenu/MlifeMenu/MlifeMenuSignedOut.styles.es.js';
import '../../MlifeMenu/MlifeMenu/MlifeMenuSignedIn.es.js';
import '../../MlifeMenu/MlifeMenu/TierProgressBar.es.js';
import '../../MlifeMenu/MlifeMenuTrigger/MlifeMenuButton.es.js';
import '../../MlifeMenu/MlifeMenuTrigger/MlifeMenuTrigger.es.js';
import '@mgmresorts/wcl-utils';
import '../../Icons/icons/createIcon.es.js';
import '../../Icons/icons/AdultsOnlyIcon.es.js';
import '../../Icons/icons/AttractionsIcon.es.js';
import '../../Icons/icons/BackIcon.es.js';
import '../../Icons/icons/BarberIcon.es.js';
import '../../Icons/icons/BedIcon.es.js';
import '../../Icons/icons/BestRateGuaranteedIcon.es.js';
import '../../Icons/icons/CalendarIcon.es.js';
import '../../Icons/icons/CartIcon.es.js';
import '../../Icons/icons/ChairIcon.es.js';
import '../../Icons/icons/CheckIcon.es.js';
import '../../Icons/icons/CirqueIcon.es.js';
import '../../Icons/icons/CloseCircleFilledIcon.es.js';
import '../../Icons/icons/CloseIcon.es.js';
import '../../Icons/icons/ComedyIcon.es.js';
import '../../Icons/icons/ConcertsIcon.es.js';
import '../../Icons/icons/CouchIcon.es.js';
import '../../Icons/icons/CreditCardIcon.es.js';
import '../../Icons/icons/CulinaryIcon.es.js';
import '../../Icons/icons/DesertViewIcon.es.js';
import '../../Icons/icons/DrinkIcon.es.js';
import '../../Icons/icons/DropdownArrowIcon.es.js';
import '../../Icons/icons/EnlargeIcon.es.js';
import '../../Icons/icons/FanIcon.es.js';
import '../../Icons/icons/FilterIcon.es.js';
import '../../Icons/icons/ForwardIcon.es.js';
import '../../Icons/icons/FreeCancellationIcon.es.js';
import '../../Icons/icons/GridDisabledIcon.es.js';
import '../../Icons/icons/GridEnabledIcon.es.js';
import '../../Icons/icons/GuestsIcon.es.js';
import '../../Icons/icons/HeartIcon.es.js';
import '../../Icons/icons/HidePasswordIcon.es.js';
import '../../Icons/icons/InformationCircleIcon.es.js';
import '../../Icons/icons/ListViewIcon.es.js';
import '../../Icons/icons/LockFilledIcon.es.js';
import '../../Icons/icons/LockOutlineIcon.es.js';
import '../../Icons/icons/LongArrowIcon.es.js';
import '../../Icons/icons/LoungeChairIcon.es.js';
import '../../Icons/icons/MagicIcon.es.js';
import '../../Icons/icons/MattressIcon.es.js';
import '../../Icons/icons/MenuIcon.es.js';
import '../../Icons/icons/MinibarIcon.es.js';
import '../../Icons/icons/MinusCircleIcon.es.js';
import '../../Icons/icons/MinusIcon.es.js';
import '../../Icons/icons/MlifeIcon.es.js';
import '../../Icons/icons/PanoramicViewIcon.es.js';
import '../../Icons/icons/PasswordXIcon.es.js';
import '../../Icons/icons/PhoneIcon.es.js';
import '../../Icons/icons/PlusCircleIcon.es.js';
import '../../Icons/icons/PlusIcon.es.js';
import '../../Icons/icons/PoolIcon.es.js';
import '../../Icons/icons/ProfileIcon.es.js';
import '../../Icons/icons/RefreshIcon.es.js';
import '../../Icons/icons/SafeIcon.es.js';
import '../../Icons/icons/SearchIcon.es.js';
import '../../Icons/icons/ShowPasswordIcon.es.js';
import '../../Icons/icons/ShowerIcon.es.js';
import '../../Icons/icons/SortIcon.es.js';
import '../../Icons/icons/SpaRocksIcon.es.js';
import '../../Icons/icons/SpecialEventsIcon.es.js';
import '../../Icons/icons/Spinner.es.js';
import '../../Icons/icons/SportsIcon.es.js';
import '../../Icons/icons/SpotCalendarIcon.es.js';
import '../../Icons/icons/StripViewIcon.es.js';
import '../../Icons/icons/TvIcon.es.js';
import '../../Icons/icons/UmbrellaIcon.es.js';
import '../../Icons/icons/WarningCircleIcon.es.js';
import '../../Icons/icons/WarningTriangleFilledIcon.es.js';
import '../../Icons/icons/WarningTriangleIcon.es.js';
import '../../Icons/icons/WiFiIcon.es.js';
import '../../Icons/icons/BestRateIcon.es.js';
import '../../Icons/icons/FiveDiamondAwardIcon.es.js';
import '../../Icons/icons/ForbesTravelGuideIcon.es.js';
import '../../Icons/icons/AriaStackedIcon.es.js';
import '../../Icons/icons/BeauRivageIcon.es.js';
import '../../Icons/icons/BellagioIcon.es.js';
import '../../Icons/icons/BellagioInternationalIcon.es.js';
import '../../Icons/icons/BorgataIcon.es.js';
import '../../Icons/icons/CircusCircusIcon.es.js';
import '../../Icons/icons/DelanoIcon.es.js';
import '../../Icons/icons/ExcaliburIcon.es.js';
import '../../Icons/icons/GoldStrikeIcon.es.js';
import '../../Icons/icons/LuxorIcon.es.js';
import '../../Icons/icons/MandalyBayIcon.es.js';
import '../../Icons/icons/MGMChinaIcon.es.js';
import '../../Icons/icons/MGMDiayutaiIcon.es.js';
import '../../Icons/icons/MGMGrandDetroitIcon.es.js';
import '../../Icons/icons/MGMGrandIcon.es.js';
import '../../Icons/icons/MGMGrandSanyaIcon.es.js';
import '../../Icons/icons/MGMMacauIcon.es.js';
import '../../Icons/icons/MGMNationalHarborIcon.es.js';
import '../../Icons/icons/MGMResortIcon.es.js';
import '../../Icons/icons/MGMSpringfieldIcon.es.js';
import '../../Icons/icons/MirageIcon.es.js';
import '../../Icons/icons/MyVegasIcon.es.js';
import '../../Icons/icons/NYNYIcon.es.js';
import '../../Icons/icons/ParkMGMIcon.es.js';
import '../../Icons/icons/SignatureIcon.es.js';
import '../../Icons/icons/VdaraIcon.es.js';
import '../../Icons/icons/FacebookIcon.es.js';
import '../../Icons/icons/TwitterIcon.es.js';
import '../../Icons/icons/YouTubeIcon.es.js';
import '../../Icons/icons/PinterestIcon.es.js';
import '../../Icons/icons/InstagramIcon.es.js';
import '../../Icons/icons/PlayMGMIcon.es.js';
import '../../Icons/icons/MGMGRIResortIcon.es.js';
import '../../ViewportContext/ViewportContext.es.js';
import '../../MlifeMenu/MlifeMenuTrigger/MobileModelHeader.styles.es.js';
import '../../RoomBookingNavigation/elements/ShoppingCart.es.js';

var _templateObject, _templateObject2, _templateObject3;
var StyledCenterElement = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex: 1;\n"])));
var StyledRoomBookingNavigation = styled(RoomBookingNavigation)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  & ", " {\n    overflow: hidden;\n    justify-content: center;\n  }\n"])), StyledCenterElement);
var StyledCenteredNavTitle = styled(CenteredNavTitle)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: static;\n  overflow: hidden;\n  & ", ", & ", " {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n"])), Text16, Heading20);

export { StyledCenterElement, StyledCenteredNavTitle, StyledRoomBookingNavigation };
